/* global System */
// register component(s) with react habitat

export default {
  GoogleMap: () => System.import('./component'),
}
